import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PartnersComponent } from './components/partners/partners.component';
import { AddPartnerComponent } from './components/add-partner/add-partner.component';
import { PartnerDetailsComponent } from './components/partner-details/partner-details.component';
import { EditPartnerComponent } from './components/edit-partner/edit-partner.component';
import { CaseDetailsComponent } from './components/case-details/case-details.component';
import { CasesComponent } from './components/cases/cases.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { UsageComponent } from './components/usage/usage.component';
import { ShipmentSmsComponent } from './components/shipment-sms/shipment-sms.component';
import { FeatureFlagsComponent } from './components/feature-flags/feature-flags.component';
import { TenantImportComponent } from './components/tenant-import/tenant-import.component';
import { CatalogsComponent } from './components/catalogs/catalogs.component';
import { CatalogDetailComponent } from './components/catalog-detail/catalog-detail.component';
import { PlansComponent } from './components/plans/plans.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { LegalDocumentsComponent } from './components/legal-documents/legal-documents.component';
import { LegalDocumentDetailComponent } from './components/legal-document-detail/legal-document-detail.component';
import { ManufacturersComponent } from './components/manufacturers/manufacturers.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AdminGuard] },
  { path: 'partners', component: PartnersComponent, canActivate: [AdminGuard] },
  { path: 'partners/add', component: AddPartnerComponent, canActivate: [AdminGuard] },
  { path: 'partners/:id', component: PartnerDetailsComponent, canActivate: [AdminGuard] },
  { path: 'partners/:id/edit', component: EditPartnerComponent, canActivate: [AdminGuard] },
  { path: 'partners/:id/import', component: TenantImportComponent, canActivate: [AdminGuard] },
  { path: 'cases', component: CasesComponent, canActivate: [AdminGuard] },
  { path: 'cases/:id', component: CaseDetailsComponent, canActivate: [AdminGuard] },
  { path: 'usage', component: UsageComponent, canActivate: [AdminGuard] },
  { path: 'shipment-sms', component: ShipmentSmsComponent, canActivate: [AdminGuard] },
  { path: 'feature-flags', component: FeatureFlagsComponent, canActivate: [AdminGuard] },
  { path: 'catalogs', component: CatalogsComponent, canActivate: [AdminGuard] },
  // Ahead of catalogs/:id, which would otherwise take 'manufacturers' as an id.
  { path: 'catalogs/manufacturers', component: ManufacturersComponent, canActivate: [AdminGuard] },
  { path: 'catalogs/:id', component: CatalogDetailComponent, canActivate: [AdminGuard] },
  { path: 'plans', component: PlansComponent, canActivate: [AdminGuard] },
  { path: 'subscriptions', component: SubscriptionsComponent, canActivate: [AdminGuard] },
  { path: 'legal-documents', component: LegalDocumentsComponent, canActivate: [AdminGuard] },
  { path: 'legal-documents/:id', component: LegalDocumentDetailComponent, canActivate: [AdminGuard] },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '404', component: NotFoundComponent },
  // Must stay last: the router takes the first match.
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
